<template>
  <div class="app-container">
    <CrudTable entity="ReturnCause" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'name', label: 'common.description' },
        {
          field: 'returnCauseOption',
          label: 'return.returnCause',
          formatter: this.formatReturnCauseOption,
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  methods: {
    formatReturnCauseOption(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('returnCause').find(item => item.code === cellValue);
      return option && option.description;
    }
  }
};
</script>

<style scoped></style>
